export enum LoggingType {
    ERROR = 'ERROR',
    INFO = 'INFO',
    WARNING = 'WARNING',
    DEBUG = 'DEBUG',
    FATAL = 'FATAL'
}
